export default {
  namespaced: true,
  state: () => ({
    isLoading: true,
    images: {
      logo: false,
      concrete: false,
      exhibits: false,
      monkey: false,
      outlet: false
    },
    exhibitA: {
      background: false,
      middle: false,
      foreground: false,
      exhibits1: false,
      exhibits2: false,
      exhibits3: false,
      monkey: false,
      outlet: false,
      concrete: false,
      ape: false
    },
    exhibitB: {
      background: false,
      middle: false,
      foreground: false,
      exhibits1: false,
      exhibits2: false,
      exhibits3: false,
      monkey: false,
      outlet: false,
      concrete: false,
      ape: false
    },
    exhibitC: {
      middle: false,
      foreground: false,
      exhibits1: false,
      exhibits2: false,
      exhibits3: false,
      monkey: false,
      outlet: false,
      concrete: false,
      ape: false
    },
    activeLoader: "images"
  }),
  mutations: {
    setLoaded(state, image) {
      state[state.activeLoader][image] = true;
    },
    changeActiveLoader(state, loader) {
      state.activeLoader = loader;
    }
  },
  getters: {
    isLoading: state => {
      return Object.values(state[state.activeLoader]).some(img => img === false);
    },
    itemsToLoad: state => {
      return Object.keys(state[state.activeLoader]).length;
    },
    itemsLoaded: state => {
      return Object.values(state[state.activeLoader]).filter(img => img === true).length;
    }
  }
};
